var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonalLoan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Cash-Payment-Bag--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cash Payment Bag Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.36 16.28c4 0 7.19 -2.89 7.19 -6.45 0 -2.77 -2.61 -5.81 -5.08 -7a0.24 0.24 0 0 1 -0.13 -0.15 0.27 0.27 0 0 1 0 -0.2l0.97 -1.6a0.56 0.56 0 0 0 -0.48 -0.88h-4.75a0.56 0.56 0 0 0 -0.48 0.85l1 1.57a0.27 0.27 0 0 1 0 0.2 0.24 0.24 0 0 1 -0.13 0.15c-2.53 1.2 -5.27 4.25 -5.27 7 -0.03 3.62 3.19 6.51 7.16 6.51Zm-0.42 -6.5C14.94 9.1 14 8.46 14 7.53A1.41 1.41 0 0 1 15.55 6s0.06 0 0.06 -0.07V5.5a0.75 0.75 0 0 1 1.5 0v0.22a0.26 0.26 0 0 0 0.25 0.25H18a0.75 0.75 0 0 1 0 1.5h-2.48a0.19 0.19 0 0 0 0 0.07 7.8 7.8 0 0 0 1.27 1c1 0.68 2 1.32 2 2.25a1.45 1.45 0 0 1 -1.56 1.56 0.07 0.07 0 0 0 -0.07 0.06v0.41a0.75 0.75 0 1 1 -1.5 0v-0.22a0.25 0.25 0 0 0 -0.25 -0.25h-0.62a0.75 0.75 0 1 1 0 -1.5h2.47a0.14 0.14 0 0 0 0 -0.07 8 8 0 0 0 -1.32 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.44 18 -3.52 1.2a0.23 0.23 0 0 0 -0.15 0.14A2 2 0 0 1 15 20.53h-4a0.5 0.5 0 0 1 -0.5 -0.5 0.5 0.5 0 0 1 0.5 -0.5h4a1 1 0 1 0 0 -2h-3.5c-0.31 0 -1.51 -1.5 -4 -1.5H5.39a4 4 0 0 0 -1.79 0.42L0.58 18a0.25 0.25 0 0 0 -0.13 0.22v5.4a0.27 0.27 0 0 0 0.12 0.22 0.27 0.27 0 0 0 0.26 0l3.22 -2a1 1 0 0 1 0.85 -0.1c10 3.36 6.63 3.37 17.87 -2.31a0.51 0.51 0 0 0 0.1 -0.85 2.49 2.49 0 0 0 -2.43 -0.58Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalLoan);
export default ForwardRef;